import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import BinIcon from '../../../components/icon/IconWrapped';
import React, { memo } from 'react';
import DesktopPopup, { IDesktopPopupProps } from '../../../components/DesktopPopup/DesktopPopup';

export type IRespawnStatusModalProps = IDesktopPopupProps;

function RespawnStatusModal(props: IRespawnStatusModalProps) {
    const { onClose, show } = props;
    const { getLangPath } = useLangContext();

    return <DesktopPopup
        show={show}
        onClose={onClose}
    >
        <div className={'d-flex flex-column align-items-center font-size-14'}>
            <BinIcon name={'IcRebuyColor'} size={80} className={'mb-2'}/>
            <div className={'text-secondary'}>{getLangPath('user_statuses.respawn.title')}</div>
            <div className={'align-self-start mt-3'}>{getLangPath('user_statuses.respawn.description')}</div>
        </div>
    </DesktopPopup>;
}

export default memo(RespawnStatusModal);
